import { useState } from 'react';
import type { FormEvent } from 'react';
import { errorText } from '../api';
import { useAuth } from '../auth';
import { Notice } from '../components/ui';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email, password);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="anmeldeseite">
      <main className="anmelde-spalte">
        <div className="anmelde-inhalt">
          {error && <Notice kind="error">{error}</Notice>}
          <form className="anmelde-card" onSubmit={submit}>
            <h2>Anmelden bei OrderFlow</h2>
            <label className="field">
              <span>E-Mail</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                autoCapitalize="none"
                spellCheck={false}
                required
                autoFocus
              />
            </label>
            <label className="field">
              <span>Passwort</span>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
            </label>
            <button type="submit" className="primary" disabled={busy} style={{ justifyContent: 'center' }}>
              {busy ? 'Anmeldung läuft …' : 'Anmelden'}
            </button>
            <p className="small muted" style={{ margin: 0 }}>
              Passwort vergessen? Ein Admin setzt es zurück.
            </p>
          </form>
        </div>
      </main>
      <aside className="marken-spalte">
        <div>
          <img src="/kg-media.svg" alt="" />
          <div className="name">OrderFlow</div>
          <p>Bestellungen, Lieferungen und Service – ohne dass etwas liegen bleibt.</p>
          <p className="small" style={{ color: 'var(--sidebar-soft)' }}>
            © {new Date().getFullYear()} K&amp;G media Handel und Service GmbH
          </p>
        </div>
      </aside>
    </div>
  );
}
